import {
  NODE_TYPES,
  EDGE_TYPES,
  REGULAR_NODE_SIZE,
  CURRENT_MVP_NODE_SIZE,
  DEFAULT_BORDER_COLOR,
  NETWORK_LAYERS,
  CURRENT_MVP_LINKING_NODE_SIZE,
  REGULAR_LINKING_NODE_SIZE,
} from './constants';
import NetworkEdges from './NetworkEdges';

export default class BmcVirtualSection {
  // Parent is either an MVP or a Value Proposition
  constructor(parent) {
    this.parent = parent;
    this.layer = NETWORK_LAYERS.BMC;

    this.oldEdgesIds = [];
  }

  get name() {
    return this.parent.store.rootStore.localeStore.intl.formatMessage({
      id: 'bmc',
    });
  }

  get myName() {
    return `${this.name}-${this.parent.name}`;
  }

  get nodeMapping() {
    const size = this.parent.currentMvp
      ? CURRENT_MVP_NODE_SIZE
      : REGULAR_NODE_SIZE;
    const mapping = {
      id: this.nodeMappingId,
      label: this.myName,
      title: this.parent.name,
      bmcBoardId: this.parent.bmcBoardId,
      igtasksBoardId: this.parent.bmcIgtasksBoardId,
      group: NODE_TYPES.BMC,
      parentId: this.parent.id,
      layer: this.layer,
      size,
      color: {
        border: DEFAULT_BORDER_COLOR,
      },
      igtasksBoardPermission: this.parent.igtasksBoardPermission,
      bmcBoardPermission: this.parent.bmcBoardPermission,
    };
    return mapping;
  }

  get linkingNodeMapping() {
    const mapping = this.nodeMapping;
    mapping.size = this.parent.nodeType == NODE_TYPES.MVP && this.parent.currentMvp
      ? CURRENT_MVP_LINKING_NODE_SIZE
      : REGULAR_LINKING_NODE_SIZE;
    mapping.label = this.name;
    // Avoid automatic selection of linking node
    // when automatically loading the VISION BMC tasks board
    mapping.igtasksBoardId = undefined;
    mapping.group = NODE_TYPES.PRODUCT_BMC;
    mapping.layer = NETWORK_LAYERS.PRODUCT;
    return mapping;
  }

  get nodeMappingId() {
    return NODE_TYPES.BMC + this.parent.bmcBoardId;
  }

  get edgesMapping() {
    let edges = [];
    edges = this.edgesFromParent;
    return edges;
  }

  get edgesFromParent() {
    const edges = [];
    const myNodeId = this.nodeMappingId;
    if (this.parent.nodeType == NODE_TYPES.MVP) {
      if (this.parent.priorMvps.length == 0) {
        const bmc = this.parent.valueProposition.virtualBmcSection;
        const fromNodeId = bmc.nodeMappingId;
        edges.push(
          NetworkEdges.generateEdge(
            EDGE_TYPES.BMC_MAIN,
            myNodeId,
            fromNodeId,
            NETWORK_LAYERS.BMC,
          ),
        );
      } else {
        for (const mvp of this.parent.priorMvps) {
          const bmc = mvp.virtualBmcSection;
          const fromNodeId = bmc.nodeMappingId;
          edges.push(
            NetworkEdges.generateEdge(
              EDGE_TYPES.BMC_MAIN,
              myNodeId,
              fromNodeId,
              NETWORK_LAYERS.BMC,
            ),
          );
        }
      }
    }
    edges.push(this.parentLinkingEdge(myNodeId));
    return edges;
  }

  parentLinkingEdge(myNodeId) {
    const { parent } = this;
    const fromNodeId = parent.linkingNodeMapping.id;
    const edgeType = parent.currentMvp
      ? EDGE_TYPES.CURRENT_MVP
      : EDGE_TYPES.BMC;
    return NetworkEdges.generateEdge(
      edgeType,
      myNodeId,
      fromNodeId,
      NETWORK_LAYERS.BMC,
    );
  }

  setOldEdgesIds() {
    this.oldEdgesIds = this.edgesMapping.map((edge) => edge.id);
  }
}
